import MenuItemComponent from './MenuItem.component';

export * from './MenuItem.component';
export default MenuItemComponent;
